import { ETH } from '../constants/assets'
import type { ChainConfig } from '../types'

export const MEGA_ETH = {
  name: 'mega-eth',
  chainId: 4326,
  averageBlockTimeSeconds: 0.01,
  explorerUrl: 'https://megaeth.blockscout.com/',
  nativeAsset: ETH,
  slip44: 60,
  wrappedNativeAsset: '0x4200000000000000000000000000000000000006',
  blockscoutApiUrl: 'https://megaeth.blockscout.com/api',
  etherscanSupported: true,
  publicRpcUrls: ['https://mainnet.megaeth.com/rpc', 'https://rpc-megaeth-mainnet.globalstake.io'],
  getPrivateRpcUrls: () => {
    const megaeth: string[] = []
    process.env.ROUTEME_API_KEY && megaeth.push(`https://lb.routeme.sh/rpc/4326/${process.env.ROUTEME_API_KEY}`)
    return megaeth
  },
} as const satisfies ChainConfig
